module.exports = __webpack_public_path__ + "static/staff-kylie-031db30b648fbb5e767abba3d99dde05.png";